<style src="./style.scss">
</style>

<script lang="ts">
  import Modal from "@components/modal";
  import Button from "@components/button";
  import TextInput from "@components/textInput";

  export let isOpen = false;
  export let onClose = () => null;
  export let onSubmit = () => null;

  let birthdate: string = "";
  let mask = "00/00/0000";

  const splitOn = (slicable, ...indices) =>
    [0, ...indices].map((n, i, m) => slicable.slice(n, m[i + 1]));

  function isValidDate(value) {
    if (value.length !== 8) {
      return false;
    }

    const date = splitOn(value, 2, 4);

    const formateDate = `${date[1]}-${date[0]}-${date[2]}`;

    const time = new Date(formateDate).getTime();

    return isNaN(time) ? false : formateDate;
  }

  function formatDate(value) {
    const date = isValidDate(value);

    onSubmit(date);
  }
</script>

<Modal isOpen="{isOpen}" title="Mudar telefone" onClose="{onClose}">
  <form on:submit|preventDefault="{() => formatDate(birthdate)}">
    <TextInput
      placeholder="DD/MM/YYYY"
      bind:mask
      type="tel"
      bind:value="{birthdate}" />

    <Button
      title="Salvar"
      onClick="{() => formatDate(birthdate)}"
      disabled="{!isValidDate(birthdate)}" />
  </form>
</Modal>
